import { render, staticRenderFns } from "./PushNotificationPopup.vue?vue&type=template&id=9b949b10"
import script from "./PushNotificationPopup.vue?vue&type=script&lang=js"
export * from "./PushNotificationPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports